// extracted by mini-css-extract-plugin
module.exports = {"off":"style_off__3SUjW","switch":"style_switch__22wzp","dot":"style_dot__zQUng"};